import { render, staticRenderFns } from "./ArtworkApprovalDetails.vue?vue&type=template&id=f63ba442&scoped=true"
import script from "./ArtworkApprovalDetails.vue?vue&type=script&lang=js"
export * from "./ArtworkApprovalDetails.vue?vue&type=script&lang=js"
import style0 from "./ArtworkApprovalDetails.vue?vue&type=style&index=0&id=f63ba442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63ba442",
  null
  
)

export default component.exports